<template>
  <div>
    <Table :columns="columns" :data="resources" size="small" highlight-row stripe max-height="700">
      <template slot-scope="{ row }" slot="barcode">
        {{ row.product ? row.product.barcode : 'N/A' }}
      </template>
      <template slot-scope="{ row }" slot="product_name">
        {{ row.product ? row.product.product_name_en : 'N/A' }}
      </template>
      <template slot-scope="{ row }" slot="expiry_date">
        {{ row.expiry_date ? row.expiry_date : 'N/A' }}
      </template>
      <template slot-scope="{ row }" slot="unit_of_measure">
        {{ row.unit_of_measure ? row.unit_of_measure.uom_name_en : 'N/A' }}
      </template>
      <template slot-scope="{ row }" slot="cost">
        <ts-display-currency :amount="row.input_cost" :currency_id="row.input_currency_id" />
      </template>
      <template slot-scope="{ row }" slot="discount">
        <b class="ts-text-blue-700" v-if="row.discount_type == '%'">
          {{ row.discount_rate + ' ' + row.discount_type }}
        </b>
        <div v-else>
          <ts-display-currency :amount="row.input_discount_rate" :currency_id="row.input_currency_id" />
        </div>
      </template>
      <template slot-scope="{ row }" slot="fx_rate">
        <div class="text-right ts-text-blue-700 ts-font-semibold">
          {{ row.fx_rate }}
        </div>
      </template>
      <template slot-scope="{ row }" slot="amount">
        <ts-display-currency :amount="row.input_grand_total" :currency_id="row.input_currency_id" />
      </template>
      <template slot-scope="{ row }" slot="converted_amount">
        <ts-display-currency :amount="row.grand_total" :currency_id="row.currency_id" />
      </template>
    </Table>
  </div>
</template>
<script>
export default {
  name: 'tableExpand',
  props: {
    row: Object
  },
  data() {
    return {}
  },
  computed: {
    resources() {
      return this.row.stock_in_details
    },
    columns() {
      return [
        {
          title: this.$t('stockIn.barcode'),
          slot: 'barcode',
          minWidth: 150,
          sortable: true,
          tooltip: true
        },
        {
          title: this.$t('stockIn.productName'),
          slot: 'product_name',
          minWidth: 150,
          sortable: true,
          tooltip: true
        },
        {
          title: this.$t('stockIn.expireDate'),
          slot: 'expiry_date',
          minWidth: 170,
          sortable: true,
          tooltip: true
        },
        {
          title: this.$t('stockIn.uom'),
          slot: 'unit_of_measure',
          minWidth: 160,
          align: 'center',
          sortable: true,
          tooltip: true
        },
        {
          title: this.$t('stockIn.cost'),
          slot: 'cost',
          minWidth: 140,
          align: 'right',
          sortable: true
        },
        {
          title: this.$t('stockIn.qty'),
          key: 'quantity',
          minWidth: 100,
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('stockIn.discount'),
          slot: 'discount',
          minWidth: 140,
          align: 'right',
          sortable: true
        },
        {
          title: this.$t('stockIn.vatRate'),
          key: 'vat_rate',
          minWidth: 140,
          align: 'right',
          sortable: true
        },
        {
          title: this.$t('stockIn.amount'),
          slot: 'amount',
          minWidth: 140,
          align: 'right',
          sortable: true
        },
        {
          title: this.$t('stockIn.convertedAmount'),
          slot: 'converted_amount',
          minWidth: 150,
          align: 'right',
          sortable: true
        },
      ]
    }
  },
  methods: {}
}
</script>
